import React from "react";
import { Checkbox, MenuItem, Select } from "@material-ui/core";

import _ from "lodash";

import {
  riskDisplayName,
  webTrackerRiskLevelAsInt,
  WebTrackerRiskLevel,
} from "./types";
import { theme } from "../theme";

export type RiskSelectProps = {
  selectedRiskValues: WebTrackerRiskLevel[];
  onChange: (value: WebTrackerRiskLevel[]) => void;
};

function sortRiskFn(a: WebTrackerRiskLevel, b: WebTrackerRiskLevel): number {
  return webTrackerRiskLevelAsInt(a) - webTrackerRiskLevelAsInt(b);
}

function titleCaseDisplayName(risk: string): string {
  if (risk === "any") {
    return "Any Risk";
  }

  const display = riskDisplayName(risk as WebTrackerRiskLevel);

  return `${display.charAt(0).toLocaleUpperCase()}${display.slice(1)}`;
}

function renderValue(selectedRiskValues: WebTrackerRiskLevel[]) {
  if (selectedRiskValues.length === 0) {
    return "Risk";
  }

  return ((selectedRiskValues as unknown) as WebTrackerRiskLevel[])
    .sort(sortRiskFn)
    .map(titleCaseDisplayName)
    .join(", ");
}

const riskSelectOptions = [
  "any",
  "high",
  "medium",
  "low",
  "unknown",
  "removed",
];

function RiskSelect({ selectedRiskValues, onChange }: RiskSelectProps) {
  return (
    <Select
      displayEmpty
      fullWidth
      multiple
      native={false}
      title={`Risk Filter: ${renderValue(selectedRiskValues)}`}
      value={selectedRiskValues}
      variant="outlined"
      onChange={(event) => {
        if ((event.target.value as string[]).includes("any")) {
          onChange([]);
          return;
        }

        onChange(_.uniq(event.target.value as WebTrackerRiskLevel[]));
      }}
      renderValue={(selected) => {
        return renderValue(selected as WebTrackerRiskLevel[]);
      }}
    >
      {riskSelectOptions.map((risk) => {
        const isSelected =
          risk === "any" && selectedRiskValues.length === 0
            ? true
            : selectedRiskValues.includes(risk as WebTrackerRiskLevel);

        return (
          <MenuItem key={`risk-select-option-${risk}`} value={risk}>
            <Checkbox
              checked={isSelected}
              size="small"
              style={{ padding: theme.spacing(0, 1, 0, 0) }}
            />
            {titleCaseDisplayName(risk)}
          </MenuItem>
        );
      })}
    </Select>
  );
}

export default RiskSelect;
